(function () {
  function initSection(section) {
    if (section.dataset.searchableFaqReady === 'true') return;
    section.dataset.searchableFaqReady = 'true';

    const chips = Array.from(section.querySelectorAll('[data-faq-chip]'));
    const items = Array.from(section.querySelectorAll('[data-faq-item]'));
    const emptyState = section.querySelector('[data-faq-empty]');
    const singleOpen = section.dataset.singleOpen === 'true';
    const openFirst = section.dataset.openFirst === 'true';
    const defaultChip = chips.find((chip) => chip.classList.contains('is-active')) || chips[0];
    let activeCategory = defaultChip?.dataset.faqChip || 'all';

    function syncSingleOpen(currentItem) {
      if (!singleOpen || !currentItem?.open) return;
      items.forEach((item) => {
        if (item !== currentItem) item.open = false;
      });
    }

    function getVisibleItems() {
      return items.filter((item) => !item.hidden);
    }

    function applyFilters() {
      let visibleCount = 0;
      let openedFirstVisible = false;

      items.forEach((item) => {
        const category = item.dataset.category || '';
        const categoryMatch = activeCategory === 'all' || category === activeCategory;
        const shouldShow = categoryMatch;

        item.hidden = !shouldShow;
        if (!shouldShow) {
          item.open = false;
          return;
        }

        visibleCount += 1;
        if (openFirst && !openedFirstVisible) {
          item.open = true;
          openedFirstVisible = true;
        } else if (singleOpen || !shouldShow) {
          item.open = false;
        }
      });

      if (emptyState) {
        emptyState.classList.toggle('is-visible', visibleCount === 0);
      }
    }

    items.forEach((item) => {
      item.addEventListener('toggle', () => syncSingleOpen(item));
    });

    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        activeCategory = chip.dataset.faqChip || 'all';
        chips.forEach((button) => {
          const isActive = button === chip;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        applyFilters();
      });
    });

    applyFilters();
  }

  function initAll() {
    document.querySelectorAll('[data-searchable-faq]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
